// extracted by mini-css-extract-plugin
export var chevronIcon = "_dw-2";
export var teamName = "_dw-1";
export var teamSwitcherButton = "_dw-0";